/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import { useState, useEffect } from 'react';
import { List, ListItem } from 'appkit-react';
import KeyCode from 'appkit-react-utils/keyCode';
import ClassNames from 'classnames';
import { useReactiveVar } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import {
    leftNavigationItemsVar, currentLeftMenuVar, moduleIdVar,
} from 'Apollo/config';
import { ModuleIdEnum, ModuleEnum } from 'constants';
import { getAllowedModule } from 'views/Auth/AuthHelper';

const outlineAction = {
    NOACTION: 0,
    CLICK: 1,
    CHANGE: 2,
    BLUR: 3,
    TAB: 4,
};

const LeftNav = () => {
    const currentMenu = useReactiveVar(currentLeftMenuVar);
    const [currMenu, setCurrMenu] = useState(currentMenu);
    const [listItems, setListItems] = useState([]);
    const [hasOutLine, setHasOutLine] = useState(true);
    const [lastAction, setLastAction] = useState(outlineAction.CLICK);
    const [moduleIds, setModuleIds] = useState([]);

    const listitems = useReactiveVar(leftNavigationItemsVar);

    const history = useHistory();

    const keyEvent = e => {
        if (e.keyCode === KeyCode.TAB) {
            // Tab key
            setLastAction(outlineAction.BLUR);
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', keyEvent, false);
        setModuleIds(getAllowedModule());
        return () => {
            window.removeEventListener('keydown', keyEvent, false);
        };
    }, []);

    useEffect(() => {
        // if (moduleIds.length) { //ToDo: Check Logic Later with Left Nav Bar Items
        //     const updatedItems = listitems.filter((l, id) => moduleIds.includes(id + 1));
        //     setListItems(updatedItems);
        // } else {
        //    setListItems(listitems);
        // }

        setListItems(listitems);
    }, [listitems, moduleIds]);

    const handleMenuClick = menu => {
        if (menu === ModuleEnum.DATARECONCILIATION) {
            history.push(
                {
                    pathname: '/data-recon-home',
                },
            );
            setCurrMenu(menu);
            currentLeftMenuVar(menu);
        } else if (menu === ModuleEnum.RULEENGINE) {
            history.push('/');
            leftNavigationItemsVar([]);
            moduleIdVar(ModuleIdEnum.RULEENGINE);
        } else if (menu === ModuleEnum.CROSSREPORTVALIDATION) {
            setCurrMenu(menu);
            currentLeftMenuVar(menu);
            history.push('/cross-report');
        } else if (menu === ModuleEnum.TRENDANALYTICS) {
            // setCurrMenu(menu);
            // currentLeftMenuVar(menu);
            // history.push('/analytics');
            window.open(process.env.REACT_APP_TRENDS_SERVICE_URL);
        } else if (menu === ModuleEnum.USER) {
            setCurrMenu(menu);
            currentLeftMenuVar(menu);
            history.push('/user-management');
        } else if (menu === ModuleEnum.TENANT) {
            setCurrMenu(menu);
            currentLeftMenuVar(menu);
            history.push('/tenant-management');
        } else if (menu === ModuleEnum.INTAKE) {
            setCurrMenu(menu);
            currentLeftMenuVar(menu);
            history.push('/interest-intake');
        }
    };

    const handleKeyDown = evt => {
        if (evt.keyCode === KeyCode.ENTER) {
            const listItemNode = document.querySelector('.a-left-navigation .a-list-item:focus');
            listItemNode.click();
        }
    };

    const onMouseDown = () => {
        setHasOutLine(false);
        setLastAction(outlineAction.CLICK);
    };

    const onBlur = () => {
        if (lastAction === outlineAction.CLICK) {
            setHasOutLine(false);
            setLastAction(outlineAction.BLUR);
        } else {
            setHasOutLine(true);
            setLastAction(outlineAction.BLUR);
        }
    };

    return (
        <div className="a-left-navigation a-apply-theme-background-gray-level-2">
            <List
                className={`a-nav-menu ${!hasOutLine ? 'a-nav-menu-no-outline' : ''}`}
                onMouseDown={onMouseDown}
                onBlur={onBlur}
            >
                {listItems.map((item, idx) => {
                    const listitemClasses = ClassNames('a-nav-menu-item', { active: currMenu === item[1].props.children });
                    return (
                        <ListItem
                            key={idx}
                            className={listitemClasses}
                            onClick={() => {
                                handleMenuClick(item[1].props.children);
                            }}
                            onKeyDown={handleKeyDown}
                            tabIndex="0"
                        >
                            {listItems[idx]}
                        </ListItem>
                    );
                })}
            </List>
        </div>
    );
};

export default LeftNav;
